import { render, staticRenderFns } from "./ServiceCatalog.vue?vue&type=template&id=4d88df25&scoped=true"
import script from "./ServiceCatalog.vue?vue&type=script&lang=js"
export * from "./ServiceCatalog.vue?vue&type=script&lang=js"
import style0 from "./ServiceCatalog.vue?vue&type=style&index=0&id=4d88df25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d88df25",
  null
  
)

export default component.exports